<template>
    <div>
        <el-dialog :visible.sync="modifyStoreDialog" width="40%" top="2vh" center :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog" :show-close=false>
        <el-card>
            <div style="height: 580px; overflow: auto;">
                <el-form label-position="left">
                    <el-row>
                        <el-col :span="12"><el-form-item label="门店编号"><el-input disabled :placeholder="response.data.code" style="width:200px"></el-input></el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="门店名称"><el-input v-model="request.name" :placeholder="response.data.name" clearable style="width:200px"></el-input></el-form-item></el-col>
                    </el-row>
                      <el-row>
                        <el-col :span="12"><el-form-item label="门店单价"><el-input v-model="request.unitPrice" :placeholder="response.data.unitPrice" clearable style="width:200px"></el-input></el-form-item></el-col>
                        <el-col :span="12">
                            <el-form-item label="计费方式">
                                <el-select v-model="request.sku" clearable style="width:200px" :placeholder="skuShow">
                                    <el-option v-for="item in this.skuType" :key="item.value" :label="item.message" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                      <el-row>
                        <el-col :span="12"><el-form-item label="封顶价格"><el-input v-model="request.maxPrice" :placeholder="response.data.maxPrice" clearable style="width:200px"></el-input></el-form-item></el-col>
                        <el-col :span="12">
                            <el-form-item>
                                <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;省</label>
                                <el-select v-model="request.province" clearable :placeholder="response.data.provinceStr" @change="provinceChoose" style="width:200px">
                                    <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="">
                                <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市</label>
                                <el-select v-model="request.city" clearable :placeholder="response.data.cityStr" @change="cityChoose" style="width:200px">
                                    <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item>
                                <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区</label>
                                <el-select v-model="request.area" clearable :placeholder="response.data.areaStr" style="width:200px">
                                    <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item>
                                <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;母品类</label>
                                <el-select v-model="request.category" clearable :placeholder="response.data.categoryStr" @change="categoryChoose" style="width:200px">
                                    <el-option v-for="item in this.category" :key="item.code" :label="item.value" :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item>
                                <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;子品类</label>
                                <el-select v-model="request.subCategory" clearable :placeholder="response.data.subCategoryStr" style="width:200px" @change="subCategoryChoose">
                                    <el-option v-for="item in this.subCategory" :key="item.code" :label="item.value" :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="连锁标识">
                                <el-radio-group v-model="request.chainFlag">
                                    <el-radio label="0">非连锁</el-radio>
                                    <el-radio label="1">连锁</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"><el-form-item label="人均消费"><el-input v-model="request.expense" :placeholder="response.data.expense" clearable style="width:200px"></el-input></el-form-item></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item>
                                <label slot="label">&nbsp;&nbsp;&nbsp;&nbsp;联系人</label>
                                <el-input v-model="request.contactName" :placeholder="response.data.contactName" style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12"><el-form-item label="联系电话"><el-input v-model="request.contactPhone" :placeholder="response.data.contactPhone" clearable style="width:200px"></el-input></el-form-item></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="开始时间">
                                <el-time-select :placeholder="response.data.openStartTime" v-model="request.openStartTime" :picker-options="pickerOptions" style="width:200px"></el-time-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="结束时间">
                                <el-time-select :placeholder="response.data.openEndTime" v-model="request.openEndTime" :picker-options="pickerOptions" style="width:200px"></el-time-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12"><el-form-item label="门店备注"><el-input v-model="request.descp" :placeholder="response.data.descp" style="width:200px"></el-input></el-form-item></el-col>
                        <el-col :span="12"><el-form-item label="门店地址"><el-input v-model="request.address" :placeholder="response.data.address" style="width:200px"></el-input></el-form-item></el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="门店照片">
                                <el-upload class="upload" :http-request="upload" :file-list="fileList" accept=".jpg, .png" action="#"
                                           :limit="fileNum" :auto-upload="false" :on-change="imageChaneg" style="float: left"
                                           list-type="picture" :on-exceed="outImgNum" :show-file-list=false ref="uploadImg">
                                    <el-button size="small" type="danger" plain icon="el-icon-picture" style="width:100px;">更换图片</el-button>
                                </el-upload>
                                <el-button size="small" type="danger" plain icon="el-icon-close" style="width:100px;margin-left:10px" @click="clearImage">取消选择</el-button>
                                <el-button size="small" type="danger" plain icon="el-icon-upload2" style="width:100px;margin-left:10px" @click="submitUpload">上传图片</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                            <el-col :span="23">
                                <div style="height: 200px;width:100%;">
                                    <img :src="url" width="100%" height="100%"/>
                                </div>
                            </el-col>
                        </el-row>
                </el-form>
            </div>
        </el-card>
        <span slot="footer" class="dialog-footer">
            <el-button @click="modifyStoreDialog = false">取消</el-button>
            <el-button type="primary" @click="uploadHttpRequest">确定</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import {getStoreInfoById, updateStoreInfo, uploadImg} from '../../api/storemanagement/psstore.js'
import {GLOBAL_URL} from '../../config/config.js'
import { formatDate } from "../../utils/date";
export default {
    data() {
        return {
            modifyStoreDialog: false,
            loading: false,
            request:{
                id: '',
                name: '',
                unitPrice: '',
                sku: '',
                maxPrice: '',
                province: '',
                provinceStr: '',
                city: '',
                cityStr: '',
                area: '',
                areaStr: '',
                address: '',
                category: '',
                categoryStr: '',
                subCategory: '',
                subCategoryStr: '',
                chainFlag: '',
                expense: '',
                contactName: '',
                contactPhone: '',
                openStartTime: '',
                openEndTime: '',
                headPic: '',
                descp: ''
            },
            response: {data: []},
            url: '',
            global: '',
            province: '',
            city: '',
            area: '',
            skuShow: '',
            category: '',
            subCategory: '',
            skuType:[
                {
                    message: '30分钟',
                    value: 30
                },
                {
                    message: '60分钟',
                    value: 60
                }
                ,
                {
                    message: '90分钟',
                    value: 90
                }
            ],
            labelPosition: 'right',
            pickerOptions: {
                start: '00:00',
                step: '00:30',
                end: '24:00'
            },
            fileNum: 1,
            fileList: []

        }
    },
    methods: {
        init(id) {
            this.request.id = id;
            this.modifyStoreDialog = true;
            getStoreInfoById(id).then(result=>{
                this.url = GLOBAL_URL.imageUrl+result.data.headPic
                this.response.data = result.data;
                this.skuType.forEach(item=>{
                    if(item.value === result.data.sku){
                        this.skuShow = item.message;
                    }
                })
                this.request.chainFlag = result.data.chainFlag;
                this.response.data.maxPrice = Number(this.response.data.maxPrice) / 100;
                this.response.data.unitPrice = this.response.data.unitPrice / 100;
                this.response.data.expense = this.response.data.expense / 100;
            })
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.modifyStoreDialog = false;
            this.request.id = "";
            this.request.name = "";
            this.request.unitPrice = "";
            this.request.sku = "";
            this.request.maxPrice = "";
            this.request.province = "";
            this.request.provinceStr = "";
            this.request.city = "";
            this.request.cityStr = "";
            this.request.area = "";
            this.request.areaStr = "";
            this.request.address = "";
            this.request.category = "";
            this.request.categoryStr = "";
            this.request.subCategory = "";
            this.request.subCategoryStr = "";
            this.request.chainFlag = "";
            this.request.expense = "";
            this.request.contactName = "";
            this.request.contactPhone = "";
            this.request.openStartTime = "";
            this.request.openEndTime = "";
            this.response.data = [];
            this.fileList = [];
            this.$refs.uploadImg.clearFiles();
        },

        /**
        * 省下拉框选择触发事件
        */
        provinceChoose(value){
        this.request.city = '';
        this.request.area = '';
        for (let item of this.province) {
            if (value == item.code) {
                this.request.provinceStr = item.value;
                this.city = item.childrenDictList
            }
        }  
        },

        /**
        * 市下拉框选择触发事件
        */
        cityChoose(value){
        this.request.area = '';
        for (let item of this.city) {
            if (value == item.code) {
                this.request.cityStr = item.value;
                this.area = item.childrenDictList;
            }
        }
        },

        /**
        * 区下拉框选择触发事件
        */
        areaChoose(value){
        this.request.area = '';
        for (let item of this.area) {
            if (value == item.code) {
                this.request.cityStr = item.value;
            }
        }
        },

        /**
         * 母品类下拉框选择
         */
        categoryChoose(value){
            this.request.subCategoryStr = "";
            for(let item of this.category) {
                if(value == item.code){
                    this.request.categoryStr = item.value;
                    this.subCategory = item.childrenDictList;
                }
            }
        },

        /**
         * 子品类下拉框选择
         */
        subCategoryChoose(value){
            for(let item of this.subCategory) {
                if(value == item.code){
                    this.request.subCategoryStr = item.value;
                }
            }
        },

        /**
         * 修改门店信息
         */
        uploadHttpRequest(){
            this.request.id = this.request.id === '' ? this.response.data.id : this.request.id;
            this.request.name = this.request.name === '' ? this.response.data.name : this.request.name;
            this.request.unitPrice = this.request.unitPrice === '' ? Number(this.response.data.unitPrice) * 100 : Number(this.request.unitPrice) * 100;
            this.request.sku = this.request.sku === '' ? this.response.data.sku : Number(this.request.sku);
            this.request.maxPrice = this.request.maxPrice === '' ? Number(this.response.data.maxPrice) * 100 : Number(this.request.maxPrice) * 100;
            this.request.province = this.request.province === '' ? this.response.data.province : Number(this.request.province);
            this.request.provinceStr = this.request.provinceStr === '' ? this.response.data.provinceStr : this.request.provinceStr;
            this.request.city = this.request.city === '' ? this.response.data.city : Number(this.request.city);
            this.request.cityStr = this.request.cityStr === '' ? this.response.data.cityStr : this.request.cityStr;
            this.request.area = this.request.area === '' ? this.response.data.area : Number(this.request.area);
            this.request.areaStr = this.request.areaStr === '' ? this.response.data.areaStr : this.request.areaStr;
            this.request.address = this.request.address === '' ? this.response.data.address : this.request.address;
            this.request.category = this.request.category === '' ? this.response.data.category : Number(this.request.category);
            this.request.categoryStr = this.request.categoryStr === '' ? this.response.data.categoryStr : this.request.categoryStr;
            this.request.subCategory = this.request.subCategory === '' ? this.response.data.subCategory : Number(this.request.subCategory);
            this.request.subCategoryStr = this.request.subCategoryStr === '' ? this.response.data.subCategoryStr : this.request.subCategoryStr;
            this.request.chainFlag = this.request.chainFlag === '' ? this.response.data.chainFlag : this.request.chainFlag;
            this.request.expense = this.request.expense === '' ? Number(this.response.data.expense) * 100 : Number(this.request.expense) * 100;
            this.request.contactName = this.request.contactName === '' ? this.response.data.contactName : this.request.contactName;
            this.request.contactPhone = this.request.contactPhone === '' ? this.response.data.contactPhone : this.request.contactPhone;
            this.request.openStartTime = this.request.openStartTime === '' ? this.response.data.openStartTime : this.request.openStartTime;
            this.request.openEndTime = this.request.openEndTime === '' ? this.response.data.openEndTime : this.request.openEndTime;
            this.request.descp = this.request.descp === '' ? this.response.data.descp : this.request.descp;
            updateStoreInfo(this.request).then(result => {
                if(result.code === '000000'){
                    this.$emit('modify-succeed','修改成功')
                    this.$message({
                        message: '修改成功',
                        type: 'success',
                        duration: 3000
                    });
                    this.closeDialog();
                }
            })
            
        },

        /**
         * 上传图片
         */
        upload(){
            if (this.fileList.length === 0) {
                this.$message.error("上传文件不能为空");
                this.loading = false;
                return;
            }else{
                const file = new FormData();
                this.fileList.forEach(item=>{
                    file.append("imgFile", item.raw);
                })
                uploadImg(file).then(result=>{
                    if(result.code === "000000"){
                        this.$message.success("上传成功");
                        this.request.headPic = result.data;
                    }else{
                        this.$message.error(result.message);
                    }
                })
            }
            
        },

        /**
         * 提交上传
         */
        submitUpload(){
            this.$refs.uploadImg.submit();
        },

        /**
         * 更换图片触发事件
         */
        imageChaneg(file,fileList){
            this.url = URL.createObjectURL(file.raw);
            this.fileList = fileList;
        },

        /**
         * 取消图片
         */
        clearImage(){
            this.$refs.uploadImg.clearFiles();
            this.url = GLOBAL_URL.imageUrl+this.response.data.headPic
        },

        /**
         * 图片超出个数触发
         */
        outImgNum(files,fileList){
            this.$message({
                message: '您已选择图片，如需更换，请先取消选择！',
                type: 'error',
                center: true

        });
        }
    },
    created() {
        this.global = JSON.parse(sessionStorage.getItem("global"));
        let dict = JSON.parse(sessionStorage.getItem("dict"));
        this.province = dict.area;
        this.category = dict.store_category;
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/storemanagement/modifyStore.vue